<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="subpage course-detail flex-column-start" ref="courseDetailRef" style="background: #ffffff">
    <Header v-if="$route.query.platform !== 'mini'" title="课程详情" :is-sub-page="true" :is-native-handle="true" ref="navBarRef">
      <!--
      <template v-slot:rightBtn>
        <span class="btn btn-share" @click="shareClick"></span>
      </template>
      -->
    </Header>

    <div v-if="mediaUrl" style="padding-bottom: 10px; box-sizing: border-box" ref="mediaRef">
      <section class="wrapper">
        <div v-if="$route.query.type === '0'" class="videoWrapper">
          <div class="video">
            <video-player
              id="courseVideoPlayer"
              class="video-player vjs-custom-skin"
               ref="videoPlayer"
              :playsinline="true"
              :options="playerOptions"
              @play="onVideoPlayClick"
            ></video-player>
          </div>
          <div class="info">
            <h2>{{this.title}}</h2>
            <p>
              <span class="read">{{this.readNum}}</span>
              <span class="comment">{{this.commentNum}}</span>
            </p>
          </div>
        </div>

        <div v-else class="audioWrapper">
          <div class="audio">
            <vue-audio :src="this.mediaUrl" @onAudioPlay="onAudioPlayClick" ref="audioPlayer"></vue-audio>
          </div>
          <div class="info">
            <h2>{{this.title}}</h2>
            <p>
              <span class="read">{{this.readNum}}</span>
              <span class="comment">{{this.commentNum}}</span>
            </p>
          </div>
        </div>
      </section>
    </div>

    <section class="content" ref="contentRef" style="padding-bottom: 0; flex: 1; overflow:hidden;">
      <div ref="scrollRef" style="overflow: hidden; height: 100%;">
        <div class="ql-snow" style="overflow: auto; height: 100%;">
          <div class="h5-web ql-editor" v-html="this.content"></div>
        </div>
      </div>
    </section>

    <!-- 在小程序上显示 -->
    <template v-if="$route.query.platform === 'mini'">
      <comment ref="commentRef" :course-id="courseId"></comment>
    </template>
  </div>
</template>

<script>
import Header from '../../../components/Header'
import VueAudio from '../../../components/VueAudio'
import Comment from '../components/Comment'
import { queryCourseDetail, buyCourse } from '@/api/course'
// import { queryCourseDetail, courseShare, buyCourse } from '@/api/course'
import { videoPlayer } from 'vue-video-player'
import 'video.js/dist/video-js.css'

export default {
  name: 'CourseDetail',
  components: {
    Header,
    VueAudio,
    videoPlayer,
    Comment
  },
  inject: ['reload'],
  data () {
    return {
      courseId: -1,
      video: null,
      title: '',
      content: '',
      readNum: '',
      commentNum: '',
      shareNum: '',
      mediaUrl: '',
      coverUrl: '',
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        autoplay: false,
        muted: false,
        loop: false,
        preload: 'auto',
        language: 'zh-CN',
        aspectRatio: '16:9',
        fluid: false,
        sources: [{
          src: '',
          type: 'video/mp4'
        }],
        poster: '',
        notSupportedMessage: '此视频无法播放，请稍后再试',
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: true,
          fullscreenToggle: true
        },
        courseValue: '',
        courseIsAccess: false,
        su: false

      }
    }
  },
  mounted () {
    try {
      this.su = this.$route.query.p === 0
    } catch (e) {
      console.error(e.message)
    }

    if (this.$route.query && this.$route.query.token) {
      this.$store.commit('setInfo', { token: this.$route.query.token })
      this.courseId = parseInt(this.$route.query.id)
    }

    this.$nextTick(() => {
      if (this.$route.query.platform === 'mini') {
        this.$refs.commentRef.getCommentAndLikeCount()
        this.$refs.commentRef.getIsLike()
      }
    })

    setTimeout(() => {
      this.getData()
    }, 500)
  },
  methods: {
    initVideo () {
      this.video = this.$video('courseVideo', {
        controls: true,
        autoplay: false,
        preload: 'auto',
        width: document.documentElement.clientWidth,
        height: '210px'
      })
    },

    getData () {
    //  var id = parseInt(this.$route.query.id)
    //  console.log("id:"+id)

      queryCourseDetail({
        courseId: parseInt(this.$route.query.id)
      }).then((res) => {
        this.title = res.data.name
        this.readNum = res.data.readNum
        this.commentNum = res.data.commentNum
        this.content = res.data.content
        this.courseValue = res.data.value
        this.courseIsAccess = res.data.accessible
        if (this.su) this.courseIsAccess = true
        if (this.$route.query.type === '0') { // video
          this.mediaUrl = res.data.medias[0].resUrl
          this.coverUrl = res.data.cover.resUrl
          console.log('we get type ==0  video =' + this.mediaUrl)
          // this.videoUrl = "http://pcsys.ybc365.com/f25ee830-d0ff-42a4-98c3-3bd8d7a96455"

          this.playerOptions.sources[0].src = this.mediaUrl

          this.playerOptions.poster = this.coverUrl
        } else { // audio
          // this.audioUrl = res.data.medias[0].resUrl

          console.log('we get type=' + this.$route.query.type + ' !=0     audio')

          //   this.mediaUrl = require('@/assets/temp/test.mp3')//test
          this.mediaUrl = res.data.medias[0].resUrl
        }
      })
    },

    shareClick () {
      console.log('课程 share  courseId' + parseInt(this.$route.query.id))
      if (!this.courseIsAccess) {
        // 弹出购买
        this.buyCourse()
      } else {
        this.shareCourse()
      }
    },
    shareCourse () {
      // courseShare({
      //   courseId:parseInt(this.$route.query.id)
      // }).then((res)=>{
      //   this.$dfzhJsBridge.share(JSON.stringify(res.data))
      // })

      console.log('share  type=' + this.$route.query.type + '  id=' + this.$route.query.id)

      this.$dfzhJsBridge.share({
        url: process.env.VUE_APP_SHARE_URL + '/course/course_detail?type=' + this.$route.query.type + '&id=' + this.$route.query.id + '&p=0',
        title: this.title === '' ? ' ' : this.title,
        description: ' '
      })
    },

    buyCourse () {
      this.$createDialog({
        type: 'confirm',
        content: '您还没有权限听课，是否使用' + this.courseValue + '积分购买？',
        confirmBtn: {
          text: '确定',
          active: true,
          disabled: false,
          href: 'javascript:;'
        },
        cancelBtn: {
          text: '取消',
          active: false,
          disabled: false,
          href: 'javascript:;'
        },
        onConfirm: () => {
          console.log('确定')
          buyCourse({
            courseId: parseInt(this.$route.query.id)
          }).then((res) => {
            // 购买成功 重新获取
            this.$createToast({
              type: 'alert',
              time: 1000,
              txt: '购买成功'
            }).show()
            this.getData()
          })
        }
      }).show()
    },

    onVideoPlayClick () {
      console.log('onVideoPlayClick')
      if (!this.courseIsAccess) {
        this.$refs.videoPlayer.player.pause()
        this.$refs.videoPlayer.player.src(this.mediaUrl)

        // 弹出购买
        this.buyCourse()
      }
    },
    onAudioPlayClick () {
      console.log('onAudioPlayClick')
      if (!this.courseIsAccess) {
        this.$refs.audioPlayer.pause()
        this.buyCourse()
      }
    }
  }
}
</script>

<style lang="stylus">
body
  background-color #f7f7f7 !important
.course-detail
  .wrapper
    padding 0
    .info
      height 74px
      h2
        font-size 15px
        padding 10px
        color #363636
        text-align left
      p
        color #B8B8B8
        padding 10px
        text-align left
        span
          margin-right 20px
          padding-left 22px
        span.read
          background url("~@/assets/images/icons/icon-read.png") no-repeat left center
          background-size 17px 17px
        span.comment
          background url("~@/assets/images/icons/icon-comment.png") no-repeat left center
          background-size 17px 17px
  .videoWrapper
    height 284px
    .video
      height 210px
      .vjs-big-play-button
        width 64px
        height 64px
        border-radius 50%
        background url("~@/assets/images/icons/icon-play.png") no-repeat center
        background-size 64px 64px
        margin: auto;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
      .video-js .vjs-big-play-button .vjs-icon-placeholder:before
        content ""
      .vjs-button > .vjs-icon-placeholder:before
        line-height 2em
  .audioWrapper
    height 156px
    .audio
      height 78px
      margin-bottom 5px
  .content
    font-size 15px
    color #363636
    padding 15px 10px
    box-sizing border-box
    h2
      margin-bottom 10px
      line-height 24px
    p
      text-align left
      line-height 22px
  .h5-web
    img
      width 100%
</style>
